import React from 'react';
import { Phone, Mail, MapPin, Clock, Droplets, VideoIcon, Wrench, Waves, Zap, Construction, ShieldCheck, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {

  return (
    <footer className="bg-white text-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-1">
              <img 
                src="/pandanewlogo.png" 
                alt="Total Repair UK Logo" 
                className="w-32 h-32 rounded-lg"
              />
              <span className="text-xl font-bold -ml-6">Total Repair UK</span>
            </div>
            <p className="text-slate-600 max-w-md text-lg">
              Professional drainage solutions delivered by fully trained and experienced staff. Fast,
reliable service you can depend on.

            </p>
          </div>

          {/* Services, Quick Links & Contact - All in one row */}
          <div className="md:col-span-2">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              
              {/* Services */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Our Services</h3>
                <div className="space-y-2">
                  <div className="flex flex-wrap gap-3">
                    <a 
                      href="/services#drain-unblocking"
                      className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors group"
                    >
                      <Droplets className="w-4 h-4 group-hover:scale-110 transition-transform" />
                      <span className="text-sm">Drain Unblocking</span>
                    </a>
                                        <a 
                      href="/services#sewer-line-services"
                      className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors group"
                    >
                      <Waves className="w-4 h-4 group-hover:scale-110 transition-transform" />
                      <span className="text-sm">Sewer Line Services</span>
                    </a>
                            <a 
                      href="/services#drain-installation"
                      className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors group"
                    >
                      <Construction className="w-4 h-4 group-hover:scale-110 transition-transform" />
                      <span className="text-sm">Drain Installation</span>
                    </a>
                    <a 
                      href="/services#water-line-repair"
                      className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors group"
                    >
                      <Zap className="w-4 h-4 group-hover:scale-110 transition-transform" />
                      <span className="text-sm">Water Line Repair</span>
                    </a>
                  </div>
                  <div className="flex flex-wrap gap-3">
                    <a 
                      href="/services#drain-repair"
                      className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors group"
                    >
                      <Wrench className="w-4 h-4 group-hover:scale-110 transition-transform" />
                      <span className="text-sm">Drain Repair</span>
                    </a>
            
                    <a 
                      href="/services#maintenance-plans"
                      className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors group"
                    >
                      <ShieldCheck className="w-4 h-4 group-hover:scale-110 transition-transform" />
                      <span className="text-sm">Maintenance Plans</span>
                    </a>
                    <a 
                      href="/services#commercial-solutions"
                      className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors group"
                    >
                      <Building2 className="w-4 h-4 group-hover:scale-110 transition-transform" />
                      <span className="text-sm">Commercial Solutions</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                <div className="space-y-2">
                  <Link to="/" className="block text-slate-600 hover:text-slate-900 transition-colors">Home</Link>
                  <Link to="/about" className="block text-slate-600 hover:text-slate-900 transition-colors">About Us</Link>
                  <Link to="/services" className="block text-slate-600 hover:text-slate-900 transition-colors">Services</Link>
                  <Link to="/pricing" className="block text-slate-600 hover:text-slate-900 transition-colors">Pricing</Link>
                  <Link to="/contact" className="block text-slate-600 hover:text-slate-900 transition-colors">Contact</Link>
                  <Link to="/privacy" className="block text-slate-600 hover:text-slate-900 transition-colors">Privacy Policy</Link>
                  <Link to="/terms" className="block text-slate-600 hover:text-slate-900 transition-colors">Terms of Service</Link>
                </div>
              </div>

              {/* Contact Info */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
                <div className="flex flex-wrap gap-3">
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4 text-slate-400" />
                    <span className="text-slate-600 text-sm">(555) 123-4567</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="w-4 h-4 text-slate-400" />
                    <span className="text-slate-600 text-sm">info@totalrepairsuk.com</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-slate-400" />
                    <span className="text-slate-600 text-sm">123 Main Street, City, State 12345</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock className="w-4 h-4 text-slate-400" />
                    <span className="text-slate-600 text-sm">Mon-Fri: 8AM-6PM</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-8 pt-8 text-center">
          <p className="text-slate-500">
            © {new Date().getFullYear()} Total Repair UK. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
